"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const DateRange_1 = __importDefault(require("@mui/icons-material/DateRange"));
const AccessTime_1 = __importDefault(require("@mui/icons-material/AccessTime"));
const Place_1 = __importDefault(require("@mui/icons-material/Place"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const ContentCopy_1 = __importDefault(require("@mui/icons-material/ContentCopy"));
const KeyboardDoubleArrowDown_1 = __importDefault(require("@mui/icons-material/KeyboardDoubleArrowDown"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const helpers_1 = require("../../../../common/helpers/helpers");
const globalVariables_1 = require("../../../../common/globalVariables");
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const services_1 = require("../../../../common/services");
const VideoPlayer_1 = __importDefault(require("../../../../common/components/Other/VideoPlayer"));
const Loader_1 = __importDefault(require("../../../../common/components/Loader/Loader"));
const CallToActionsInModal_1 = __importDefault(require("../../Detail/CallToActionsInModal"));
const BookingForm_1 = __importDefault(require("../../Booking/BookingForm"));
const Map_1 = __importDefault(require("../../Pages/Map"));
const ShoppingCartRedesign_1 = __importDefault(require("../../ShoppingCart/ShoppingCartRedesign"));
const BookingLinkoutView_1 = __importDefault(require("./BookingLinkoutView"));
const CallToActionArea_1 = __importDefault(require("../../../../common/components/CallToActions/CallToActionArea"));
const ActivityListItem_1 = require("../../Other/ActivityListItem");
const ActivityDetailModalContentWrapper = styled_components_1.default.div `
  --lateral-padding: 16px;
  height: 100%;
  bottom: 0;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;

  .description-content {
    flex-grow: 1;
    padding: 12px 0 0;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .scrollable-content {
    width: 100%;
    flex-grow: 1;
    height: 300px;
    overflow-y: auto;
    padding-inline: var(--lateral-padding);
  }

  .title {
    margin-bottom: 8px;
    padding-inline: var(--lateral-padding);
  }

  .statuses-location-wrapper {
    svg {
      height: 1rem;
    }
  }

  .call-to-action-detail {
    margin-top: 16px;
    width: auto;

    .secondary-text {
      font-size: 1rem;
    }
    .main-text {
      font-size: 1rem;
    }
    canvas {
      width: 200px !important;
      height: 200px !important;

      border: 10px solid #fff;
    }
  }
  .navigation {
    width: 100%;
    header {
      position: relative;
    }
  }

  .collapse-btn {
    cursor: pointer;
    z-index: 12;

    &:hover {
      opacity: 1;
      background-color: #fff;
    }

    &.dark {
      color: #fff;
      background-color: #808080;
    }
  }

  .snackbar {
    position: absolute;
    bottom: 8px;
  }

  .copy-btn {
    cursor: pointer;
    z-index: 12;

    &:hover {
      opacity: 1;
      background-color: #fff;
    }

    &.dark {
      color: #fff;
      background-color: #808080;
    }
  }

  .call-to-actions {
    width: 100%;

    .call-to-action-icon {
      width: 36px;
      height: 36px;

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`;
const BookBtnWrapper = styled_components_1.default.div `
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 16px;
  background-color: #fff;

  border-top: 2px solid rgba(0, 0, 0, 0.1);
`;
const BookBtn = (0, styled_components_1.default)(Button_1.default) `
  width: 100%;
`;
const Description = styled_components_1.default.div `
  color: rgba(0, 0, 0, 0.87);
  letter-spacing: 0.25px;
  width: 100%;
  font-size: 1rem; // body1

  ul {
    padding: revert;
    list-style-type: initial;

    & > li {
      list-style-type: initial;
    }
  }

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
`;
const Statuses = styled_components_1.default.div `
  margin: 8px 0 12px;

  .time-and-date {
    display: flex;
  }

  div {
    margin-right: 12px;
  }

  .booking-status {
    margin-left: 8px;
    margin-top: 8px;
  }

  .time-interval,
  .date,
  .item-status {
    display: flex;
    align-items: center;
    color: #807e7e;
  }

  .statuses-icon {
    color: #807e7e;
  }
`;
const ContentTitle = styled_components_1.default.div `
  margin: 0;
`;
const LocationComp = styled_components_1.default.div `
  display: flex;
  color: #807e7e;
  margin: 8px 5px 8px 0;

  svg {
    position: relative;
    top: 2px;
  }

  span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;
const ImageWrapper = styled_components_1.default.div `
  height: 30vh;
  @media (min-width: 600px) {
    height: 35vh;
  }
  @media (min-width: 1024px) {
    height: 30vh;
  }

  transition: height ${props => props.expansionDuration / 1000}s;

  &.hidden-img {
    height: 0px;
  }
`;
const ItemImage = styled_components_1.default.div `
  height: calc(30vh + 25px);
  @media (min-width: 600px) {
    height: calc(35vh + 25px);
  }
  @media (min-width: 1024px) {
    height: calc(30vh + 25px);
  }

  width: 100%;
  flex-shrink: 0;
  transition: height ${props => props.expansionDuration / 1000}s;
  background: linear-gradient(
    12deg,
    ${props => props.theme.palette.mainAppColor.dark} 5%,
    ${props => props.theme.palette.mainAppColor.light} 25%,
    ${props => props.theme.palette.mainAppColor.main} 100%
  );
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${props => {
    if (props.src) {
        return props.src;
    }
    return null;
}};

  &.hidden-img {
    height: 0px;
  }
`;
const VideoWrapper = styled_components_1.default.div `
  height: 30vh;
  @media (min-width: 600px) {
    height: 35vh;
  }
  @media (min-width: 1024px) {
    height: 30vh;
  }
  position: relative;
  background-color: #000;
  transition: height ${props => props.expansionDuration / 1000}s;

  .brightcove-react-player-loader .video-js {
    padding-top: 0;
  }
  &.hidden-img {
    height: 0px;
  }
`;
const MapContainer = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  margin-top: 16px;
  .g-maps-container {
    width: 100%;
  }
`;
const ContactContainer = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const EXPANSION_DURATION = 600;
const ActivityDetailsModal = ({ content, currentLocale, userData, history, onClose, itemsInCart, setItemsInCart, setShowDiscardShoppingCartDialog, showDiscardShoppingCartDialog, setIsOpen, orderCompleted, setOrderCompleted, timezone, disableParticipateButton, disabledParticipateButtonText, }) => {
    var _a, _b;
    const [details, setDetails] = (0, react_1.useState)(null);
    const [imageIsHidden, setImageIsHidden] = (0, react_1.useState)(false);
    const [showBookingForm, setShowBookingForm] = (0, react_1.useState)(false);
    const [showBookingLinkout, setShowBookingLinkout] = (0, react_1.useState)(false);
    const [showMap, setShowMap] = (0, react_1.useState)(false);
    const [showPhone, setShowPhone] = (0, react_1.useState)(false);
    const [showEmail, setShowEmail] = (0, react_1.useState)(false);
    const [showShoppingCart, setShowShoppingCart] = (0, react_1.useState)(false);
    const [video, setVideo] = (0, react_1.useState)(null);
    const [clickFromCollapseBtn, setClickFromCollapseBtn] = (0, react_1.useState)(false);
    const [showVideo, setShowVideo] = (0, react_1.useState)(true);
    const [toast, setToast] = (0, react_1.useState)('');
    const contentOrDetails = content.id ? content : details;
    const isLinkoutBooking = ((_a = details === null || details === void 0 ? void 0 : details.availability) === null || _a === void 0 ? void 0 : _a.linkoutBooking) || ((_b = content === null || content === void 0 ? void 0 : content.availability) === null || _b === void 0 ? void 0 : _b.linkoutBooking);
    (0, react_1.useEffect)(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const shouldOpenBookingLinkout = searchParams.get('status') === 'success';
        if (!shouldOpenBookingLinkout || !isLinkoutBooking) {
            return;
        }
        setImageIsHidden(true);
        setShowVideo(false);
        setShowMap(false);
        setShowPhone(false);
        setShowEmail(false);
        setShowShoppingCart(false);
        setShowBookingForm(false);
        setShowBookingLinkout(true);
        searchParams.delete('status');
        const nextSearch = searchParams.toString();
        window.history.replaceState({}, '', `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}`);
    }, [isLinkoutBooking]);
    const hideToast = () => {
        setToast('');
    };
    (0, react_1.useEffect)(() => {
        services_1.apiService.getActivity(currentLocale, userData.token, `${content.contentId}`).then(detailData => {
            var _a;
            setDetails(detailData);
            if (((_a = detailData === null || detailData === void 0 ? void 0 : detailData.videos) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setVideo(...[detailData.videos]);
            }
        });
    }, []);
    if (!content.id && details === null) {
        return react_1.default.createElement(Loader_1.default, null);
    }
    const hideImage = () => {
        if (video) {
            setImageIsHidden(true);
            setTimeout(() => {
                setShowVideo(false);
            }, EXPANSION_DURATION);
            return;
        }
        setImageIsHidden(true);
    };
    const redirectLocation = (contentOrDetails === null || contentOrDetails === void 0 ? void 0 : contentOrDetails.deeplink) ? new URL(contentOrDetails === null || contentOrDetails === void 0 ? void 0 : contentOrDetails.deeplink).pathname : '/';
    const transitionToItemDetail = () => {
        history.push({
            pathname: `${redirectLocation}`,
            // eslint-disable-next-line  no-restricted-globals
            search: location.search,
        });
    };
    const bookBtnText = details &&
        details.availability &&
        details.availability.textsForDisplay &&
        details.availability.textsForDisplay.bookButton
        ? details.availability.textsForDisplay.bookButton
        : null;
    const handleClick = () => {
        hideImage();
        if (isLinkoutBooking) {
            return setShowBookingLinkout(true);
        }
        if (details && details.shoppingCartCatalogId !== null) {
            return setShowShoppingCart(true);
        }
        return setShowBookingForm(true);
    };
    const imgUrl = details && details.images && details.images[0] && details.images[0]['2:1'] && details.images[0]['2:1'].L
        ? `url( ${details.images[0]['2:1'].L} )`
        : null;
    const showDevButton = window.location.search.includes('dev-mode=true');
    const renderMainContent = () => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "statuses-location-wrapper" },
            (contentOrDetails === null || contentOrDetails === void 0 ? void 0 : contentOrDetails.placeName) && (react_1.default.createElement(LocationComp, null,
                react_1.default.createElement(Place_1.default, null),
                react_1.default.createElement(Typography_1.default, { variant: "body2" }, contentOrDetails === null || contentOrDetails === void 0 ? void 0 : contentOrDetails.placeName))),
            react_1.default.createElement(Statuses, null,
                react_1.default.createElement("div", { className: "time-and-date" },
                    getActivityTime(contentOrDetails, currentLocale, timezone),
                    react_1.default.createElement("div", { className: "date" },
                        react_1.default.createElement(DateRange_1.default, { className: "statuses-icon" }),
                        react_1.default.createElement(Typography_1.default, { variant: "body2" }, getActivityDate(contentOrDetails === null || contentOrDetails === void 0 ? void 0 : contentOrDetails.start, currentLocale, timezone)))),
                (0, ActivityListItem_1.renderBookingAvailability)(contentOrDetails))),
        details ? (react_1.default.createElement(CallToActionsInModal_1.default, { activeItem: { content: details, type: 'activity' }, openMap: () => {
                setShowMap(true);
                hideImage();
            }, openPhone: () => {
                setShowPhone(true);
                hideImage();
            }, openEmail: () => {
                setShowEmail(true);
                hideImage();
            } })) : (react_1.default.createElement(Loader_1.default, null)),
        react_1.default.createElement(Description, { dangerouslySetInnerHTML: {
                __html: (contentOrDetails === null || contentOrDetails === void 0 ? void 0 : contentOrDetails.text) || null,
            } }),
        showDevButton && (react_1.default.createElement("button", { onClick: () => {
                transitionToItemDetail();
                onClose();
            } },
            ' ',
            "Dev Btn: Go to Deeplink"))));
    const renderMapContent = () => react_1.default.createElement(MapContainer, null, details && react_1.default.createElement(Map_1.default, { selectedVenue: details }));
    const locale = details && details.locale ? details.locale : currentLocale;
    const renderEmail = () => (react_1.default.createElement(ContactContainer, null, details && details.email && (react_1.default.createElement(CallToActionArea_1.default, { mainText: details.email, secondaryText: i18n_js_1.default.t('dictionary.handover.email_message', {
            locale,
        }), qrValue: details.email }))));
    const renderPhone = () => (react_1.default.createElement(ContactContainer, null, details && details.phone && (react_1.default.createElement(CallToActionArea_1.default, { mainText: details.phone, secondaryText: i18n_js_1.default.t('dictionary.handover.call_message', { locale }), qrValue: details.phone }))));
    const renderBookingForm = () => (react_1.default.createElement(react_1.default.Fragment, null, details && (react_1.default.createElement(BookingForm_1.default, { activeItem: { content: details, type: 'activity' }, walkinRegistration: false, disableStartTime: true }))));
    const renderBookingLinkout = () => react_1.default.createElement(BookingLinkoutView_1.default, { content: contentOrDetails });
    const renderShoppingCart = () => (react_1.default.createElement(react_1.default.Fragment, null, details && (react_1.default.createElement(ShoppingCartRedesign_1.default, { activeItem: { content: details, type: details.type }, setItemsInCart: setItemsInCart, setShowDiscardShoppingCartDialog: setShowDiscardShoppingCartDialog, showDiscardShoppingCartDialog: showDiscardShoppingCartDialog, onClose: onClose, setIsOpen: setIsOpen, setShowShoppingCart: setShowShoppingCart, clickFromCollapseBtn: clickFromCollapseBtn, setClickFromCollapseBtn: setClickFromCollapseBtn, setImageIsHidden: setImageIsHidden, orderCompleted: orderCompleted, setOrderCompleted: setOrderCompleted, setShowVideo: setShowVideo, disableStartTime: true }))));
    const DisabledText = (0, styled_components_1.default)(Typography_1.default) `
    text-align: center;
    margin-bottom: 16px;
    color: ${props => props.theme.palette.text.primary};
  `;
    const renderButton = () => {
        const isDisabled = disableParticipateButton || !(contentOrDetails === null || contentOrDetails === void 0 ? void 0 : contentOrDetails.bookable);
        return (react_1.default.createElement(BookBtnWrapper, null,
            disabledParticipateButtonText && (react_1.default.createElement(DisabledText, { variant: "body1" }, decodeURIComponent(disabledParticipateButtonText))),
            react_1.default.createElement(BookBtn, { variant: "contained", onClick: () => {
                    if (!isDisabled) {
                        handleClick();
                    }
                }, disabled: isDisabled }, bookBtnText || (isDisabled ? 'Not Available' : 'Book Now'))));
    };
    const imageHiddenClass = imageIsHidden ? 'hidden-img' : '';
    const showCloseIcon = !showMap && !showBookingForm && !showBookingLinkout && !showShoppingCart && !showPhone && !showEmail;
    return (react_1.default.createElement(ActivityDetailModalContentWrapper, { contentWidth: globalVariables_1.WEB_APP.MODAL_WIDTH, contentModalBP: globalVariables_1.WEB_APP.SHOW_CONTENT_AS_MODAL_BP },
        video ? (react_1.default.createElement(VideoWrapper, { expansionDuration: EXPANSION_DURATION, className: `${imageHiddenClass} ` }, showVideo && (react_1.default.createElement(VideoPlayer_1.default, { expansionDuration: EXPANSION_DURATION, className: `${imageHiddenClass} `, video: video && video[0] })))) : (react_1.default.createElement(ImageWrapper, { expansionDuration: EXPANSION_DURATION, className: `${imageHiddenClass}` },
            react_1.default.createElement(ItemImage, { className: `item-image ${imageHiddenClass}`, expansionDuration: EXPANSION_DURATION, src: imgUrl }))),
        showCloseIcon && (react_1.default.createElement(IconButton_1.default, { className: `copy-btn ${showCloseIcon ? '' : 'dark'}`, sx: {
                position: 'absolute',
                right: 77,
                top: 12,
                color: '#000',
                zIndex: '2',
                backgroundColor: '#fff',
                opacity: '0.75',
            }, onClick: () => {
                if (contentOrDetails) {
                    let link = contentOrDetails === null || contentOrDetails === void 0 ? void 0 : contentOrDetails.deeplink;
                    if (contentOrDetails.type === 'convention_activity') {
                        // eslint-disable-next-line  no-restricted-globals
                        link = location.href;
                    }
                    setToast(i18n_js_1.default.t('link_copied_to_clipboard'));
                    navigator.clipboard.writeText(link);
                }
            } },
            react_1.default.createElement(ContentCopy_1.default, null))),
        react_1.default.createElement(IconButton_1.default, { "aria-label": "close", className: `collapse-btn ${showCloseIcon ? '' : 'dark'}`, onClick: () => {
                setClickFromCollapseBtn(true);
                if ((showMap || showPhone || showEmail || showBookingForm || showBookingLinkout || showShoppingCart) &&
                    !itemsInCart) {
                    setImageIsHidden(false);
                    setShowMap(false);
                    setShowPhone(false);
                    setShowEmail(false);
                    setShowBookingForm(false);
                    setShowBookingLinkout(false);
                    setShowShoppingCart(false);
                    setShowVideo(true);
                }
                else {
                    onClose();
                }
                if (orderCompleted) {
                    setImageIsHidden(false);
                    setShowVideo(true);
                }
                if (!showCloseIcon && itemsInCart) {
                    setShowDiscardShoppingCartDialog(true);
                }
            }, sx: {
                position: 'absolute',
                right: 17,
                top: 12,
                color: '#000',
                zIndex: '2',
                backgroundColor: '#fff',
                opacity: '0.75',
            } }, showCloseIcon ? react_1.default.createElement(Close_1.default, null) : react_1.default.createElement(KeyboardDoubleArrowDown_1.default, null)),
        react_1.default.createElement("div", { className: "description-content" },
            react_1.default.createElement(ContentTitle, { className: "title" },
                react_1.default.createElement(Typography_1.default, { variant: "h5" }, contentOrDetails === null || contentOrDetails === void 0 ? void 0 : contentOrDetails.title)),
            react_1.default.createElement("div", { className: "scrollable-content" }, (() => {
                if (showMap) {
                    return renderMapContent();
                }
                if (showPhone) {
                    return renderPhone();
                }
                if (showEmail) {
                    return renderEmail();
                }
                if (showBookingForm) {
                    return renderBookingForm();
                }
                if (showBookingLinkout) {
                    return renderBookingLinkout();
                }
                if (showShoppingCart) {
                    return renderShoppingCart();
                }
                return renderMainContent();
            })())),
        (() => {
            if (details &&
                details.availability &&
                details.availability.availabilityState &&
                (details.availability.availabilityState === 'available' ||
                    details.availability.availabilityState === 'few_places_left' ||
                    details.availability.availabilityState === 'user_has_active_booking') &&
                !showMap &&
                !showPhone &&
                !showEmail &&
                !showBookingForm &&
                !showBookingLinkout &&
                !showShoppingCart) {
                return renderButton();
            }
            return null;
        })(),
        react_1.default.createElement(material_1.Snackbar, { onClose: hideToast, autoHideDuration: 4000, open: Boolean(toast), message: toast, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, className: "snackbar", action: react_1.default.createElement(ContentCopy_1.default, { fontSize: "small" }) })));
};
function getActivityDate(dateStart, currentLocale, timezone) {
    if (!dateStart) {
        return null;
    }
    const { date } = helpers_1.Helpers.getDateFromStringDependingLocale(dateStart, currentLocale, timezone);
    return `${date}`;
}
function getActivityTime(content, currentLocale, timezone) {
    if (!content) {
        return null;
    }
    if (!content.showStartTime && !content.showEndTime) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const startTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.start, currentLocale, timezone).time;
    const endTime = helpers_1.Helpers.getDateFromStringDependingLocale(content.end, currentLocale, timezone).time;
    const time = content.showStartTime && content.showEndTime ? `${startTime} - ${endTime}` : startTime;
    return (react_1.default.createElement("div", { className: "time-interval" },
        react_1.default.createElement(AccessTime_1.default, { className: "statuses-icon" }),
        react_1.default.createElement(Typography_1.default, { variant: "body2" }, time)));
}
const mapStoreToProps = store => ({
    timezone: store.getValue('timezone'),
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(ActivityDetailsModal));
